const credentials = {
  remove: "Remove",
  UploadAnother: "Upload another",
  continueToUpdate: "Please continue to update your credentials.",
  ReadyToUpload: "Ready to upload",
  UploadDescription:
    "File was attached, you can now upload it to the server, by clicking on the upload button.",
  fullscriptWillReview: {
    normal:
      "Fullscript will review your credentials and notify you once completed. On average, this will take up to two business days. Patients will be able to view your recommendations in the meantime, and orders can be placed from your store once you are approved.",
    dynamicTerm:
      "Fullscript will review your credentials and notify you once completed. On average, this will take up to two business days. {{capitalizedPatientsTerm}} will be able to view your {{treatmentPlanTerm}} in the meantime, and orders can be placed from your store once you are approved.",
    student:
      "Fullscript will review your student credentials and notify you once approved. On average, this will take up to two business days. After that, friends and family will be able to order supplements.",
    emerson:
      "Emerson Ecologics will review your credentials and notify you once completed. This may take up to two business days.",
  },
  weWillReview:
    "We'll review your credentials and notify you once completed. This will take up to two business days.",
  dragAndDrop: "Drag & drop credentials",
  dragAndDropStudent: "Drag & drop your proof of enrollment",
  yourProfessionalLicense: "Your professional license or permit to practice",
  otherFormats: "Your degree, diploma or applicable education",
  ACopyofStudentID:
    "A photo or scanned copy of your proof of enrollment (with your name, the program and school)",
  browseComputer: "Upload credentials",
  rejectedFilesError: "You must upload only one valid image or pdf file at a time",

  experiments: {
    certUpAddressBack: {
      license: "Preferred: Healthcare license or registration (with name and expiry)",
      otherFormats: "Other formats: Healthcare degree, diploma, certificate, etc.",
      preferred: "<1>Preferred:</1> Healthcare license or registration (with name and expiry)",
      formats: "<1>Other formats:</1> Healthcare degree, diploma, certificate, etc.",
    },
  },
  Upload: "Upload certification",
  CertTitle: "Professional certifications",
  pleaseUploadCredentialsFile: "Please upload your credentials",
  CredentialFile: "Credential file",
  DateAdded: "Date added",
  Expiry: "Expiry date",
  Status: "Status",
  Empty: {
    Title: "Upload your professional certification.",
    Description:
      "Before you can order products, we will review your credentials to ensure all healthcare providers meet Emerson Ecologics professional standards. This may take up to 1 business day.",
    LearnMore: "Learn more",
  },
  npiErrors: {
    notRecognizedOnboarding:
      "We couldn't find this NPI in the <registryLink>national registry</registryLink>. Double-check the 10-digit number and try again, or upload a certificate instead.",
    notRecognizedLabs:
      "We couldn't find this NPI in the <registryLink>national registry</registryLink>. Please double-check the 10-digit number and enter it again.",
    ineligibleLabs:
      "We couldn't verify this NPI automatically. Please confirm your information matches your NPI listing in the <registryLink>national registry</registryLink>, or contact <labsEmailLink>labs@fullscript.com</labsEmailLink> to complete set-up.",
    firstNameMismatchOnboarding:
      "The first name you entered doesn't match this NPI's listing in the <registryLink>national registry</registryLink>. Please make sure it matches exactly.",
    firstNameMismatchLabs:
      "The first name you entered doesn't match this NPI's listing in the <registryLink>national registry</registryLink>. Please make sure it matches exactly. (This won't change how it appears on your Fullscript profile.)",
    lastNameMismatchOnboarding:
      "The last name you entered doesn't match this NPI's listing in the <registryLink>national registry</registryLink>. Please make sure it matches exactly.",
    lastNameMismatchLabs:
      "The last name you entered doesn't match this NPI's listing in the <registryLink>national registry</registryLink>. Please make sure it matches exactly. (This won't change how it appears on your Fullscript profile.)",
    fullNameMismatchOnboarding:
      "The name you entered doesn't match this NPI's listing in the <registryLink>national registry</registryLink>. Please make sure it matches exactly.",
    fullNameMismatchLabs:
      "The name you entered doesn't match this NPI's listing in the <registryLink>national registry</registryLink>. Please make sure it matches exactly. (This won't change how it appears on your Fullscript profile.)",
    modalityMismatchLabs:
      "The health profession registered with this NPI doesn't match the health profession listed on your Fullscript profile. Please contact <labsEmailLink>labs@fullscript.com</labsEmailLink> for support.",
    newTaxonomyLabs:
      "The health profession registered with this NPI doesn't have a clear match to any Fullscript health professions. Please contact <labsEmailLink>labs@fullscript.com</labsEmailLink> for support.",
    regionMismatch: "The state associated with the NPI number doesn't match.",
    unableToConnectOnboarding:
      "Our platform is currently unable to connect to the NPI Registry. Please try again, or upload a certificate instead.",
    unableToConnectLabs: "Unable to connect to NPI Registry. Please try again.",
    genericOnboarding: "Something went wrong. Please try again, or upload a certificate instead.",
    genericLabs: "Something went wrong. Please try again.",
  },
} as const;

export { credentials };
